import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Col, Row, Card, Badge } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import { MapPin, Phone, Globe, Mail, MailCheck } from "lucide-react";
import localization from "services/localization";
import CustomSelect from "views/Components/CustomSelect";
import { ORGANIZATION_TYPES, ORGANIZATION_SUB_TYPES } from "services/constants";
import ArrayInput from "views/Components/ArrayInput";
import ImageLibrary from "views/Components/ResourceLibrary/ImageLibrary";

const AddEditOrganizationModal = ({ show, title, formData, onChange, onSubmit, onClose, loading, errors }) => {
  const [schoolLogo, setSchoolLogo] = useState(null);

  useEffect(() => {
    if (show) {
      console.log("formData:", formData);
    }
  }, [show]);
  const handleUpperCaseChange = (e) => {
    const { name, value } = e.target;
    const upper = ["code", "codice_meccanografico", "piva", "codice_fiscale"].includes(name)
      ? value.toUpperCase()
      : value;
    onChange(name, upper);
  };

  const addArrayValue = (field, value) => {
    const current = formData[field] || [];
    onChange(field, [...current, value]);
  };

  const removeArrayValue = (field, value) => {
    const current = formData[field] || [];
    onChange(
      field,
      current.filter((v) => v !== value),
    );
  };

  return (
    <Modal show={show} onHide={onClose} centered size="m" className="themed-modal addEditModal">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Form onSubmit={onSubmit}>
        <Modal.Body className="credit-modal">
          <div className="d-flex flex-column align-items-center w-100">
            {/* Organization Name */}
            <div className="mb-8 mt-8 w-100 text-center">
              <div className="fw-bold fs-5">{formData.name || "-"}</div>
            </div>

            {/* Total Credit */}
            <Form.Group className="mb-3 w-100">
              <Form.Label className="bootstrap-label">{localization.TotalCredit || "Total Credit"}</Form.Label>

              <Form.Control
                type="number"
                min={0}
                name="credit_amount"
                value={formData.credit_amount || ""}
                onChange={(e) => onChange("credit_amount", e.target.value)}
                placeholder={localization.enter_total_credit || "Enter total credit"}
                isInvalid={!!errors.credit_amount}
              />

              <Form.Control.Feedback type="invalid">{errors.credit_amount}</Form.Control.Feedback>
            </Form.Group>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className="action-btn secondary" onClick={onClose}>
            {localization.cancel || "Cancel"}
          </Button>
          <Button className="action-btn primary" type="submit" disabled={loading}>
            {loading ? <ClipLoader size={20} color="var(--primary-icon)" /> : localization.save || "Save"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddEditOrganizationModal;
